import React, { useContext, useState } from 'react'
import {
  StepHeading,
  StepDescription,
  ButtonOption,
  ContentContainer,
} from 'components/GetStarted/styles'
import PrimaryButton from 'components/generic/PrimaryButton'
import { trackClickEvent } from 'utils/Analytics'
import { getHeadingForUserType } from 'utils/getStartedUtils'
import { AppContext } from 'contexts/AppContext'

const StepSponsorship = ({ userInput, onStepComplete }) => {
  const { domain } = useContext(AppContext)
  const defaultValue = typeof userInput?.sponsorship === 'boolean' ? userInput?.sponsorship : null
  const [sponsorship, setSponsorship] = useState(defaultValue)
  const heading = getHeadingForUserType({
    userType: userInput?.user_type,
    providerHeading: `Do you require a Work Sponsorship?`,
    seekerHeading: `Are you willing to Sponsor an Overseas Applicant?`,
    defaultHeading: `Are you willing to sponsor or do you require sponsorship?`,
  })
  const description = getHeadingForUserType({
    userType: userInput?.user_type,
    providerHeading: `Are you an overseas applicant requiring sponsorship by a family?`,
    seekerHeading: `Families may hire overseas candidates to work in their households`,
  })
  const onNextClick = () => {
    trackClickEvent(domain, 'get-started-next-sponsorship')
    onStepComplete({ sponsorship })
  }
  return (
    <ContentContainer>
      <StepHeading>{heading}</StepHeading>
      <StepDescription>{description}</StepDescription>
      <ButtonOption selected={sponsorship === false} onClick={() => setSponsorship(false)}>
        No
      </ButtonOption>
      <ButtonOption selected={sponsorship === true} onClick={() => setSponsorship(true)}>
        Yes
      </ButtonOption>
      <PrimaryButton mt='2rem' disabled={sponsorship === null} onClick={onNextClick}>
        Next
      </PrimaryButton>
    </ContentContainer>
  )
}

export default StepSponsorship
